import React from 'react';

import "./Button.styles.sass";

type ButtonTypes = 'save' | 'error';
type ButtonProps = {
  text: string,
  onClick: () => void,
  type?: ButtonTypes
}

export const Button = ({text, onClick, type}: ButtonProps) => {
  return <button className={`button ${type || ''}`} onClick={onClick}>{text}</button>;
};
